import { useState, useEffect } from "react";
import localStoreService from "@/services/middleware/storageService";
import type { Relationship } from "@/types/model/Roles";
import { SELFSERVICE_PLANS } from "@/utilities/constants";
import { routesMap } from "@/components/routes/routes";
import { useRelationshipsStore } from "@/zustand/relationshipsStore";
import { useUsersStore } from "@/zustand/usersStore";
import { FT_NAME } from "@/components/routes/feature-access/featureAccessResolver";

const useBaseRoute = ({
  isOverviewVisible = false,
}: {
  isOverviewVisible?: boolean;
}) => {
  const { planType = "" } = useUsersStore((state) => state.user);
  const { relationships } = useRelationshipsStore((state) => state);
  const [baseRoute, setBaseRoute] = useState(routesMap.base.path);
  const isRelationshipPickerForced: boolean = new URL(
    window.location.href
  ).searchParams.has("forceSelection");
  const activeRelationship: string | null = isRelationshipPickerForced
    ? null
    : localStoreService.getItem("activeRelationshipId");
  const relationshipFeatures = relationships?.find(
    (relationship: Relationship) => relationship.id === activeRelationship
  )?.accountFeatures;

  const isAdv =
    relationshipFeatures?.find(
      (el: { name: string }) => el.name === FT_NAME.OVERVIEW
    )?.value === "enabled_and_default_landing";

  useEffect(() => {
    if (
      !(planType && SELFSERVICE_PLANS.includes(planType)) &&
      !(isOverviewVisible && isAdv)
    ) {
      setBaseRoute(routesMap.intelligence.analytics.path);
    } else {
      setBaseRoute(routesMap.intelligence.overview.path);
    }
  }, [planType]);

  return { baseRoute };
};

export default useBaseRoute;
